document.addEventListener('DOMContentLoaded', () => {
  let lastSpawn = 0;

  function handleSparkleMove(e) {
    const now = Date.now();
    if (now - lastSpawn < 30) return;
    lastSpawn = now;

    // Extract coordinates correctly whether from desktop pointer or mobile touch
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    // Prevent spawning off-screen if touch coordinates are undefined
    if (clientX === undefined || clientY === undefined) return;

    const sparkle = document.createElement('div');
    sparkle.className = 'sparkle';

    sparkle.style.left = `${clientX}px`;
    sparkle.style.top = `${clientY}px`;

    const dx = (Math.random() - 0.5) * 50;
    const dy = Math.random() * 50 + 20;

    sparkle.style.setProperty('--dx', `${dx}px`);
    sparkle.style.setProperty('--dy', `${dy}px`);

    document.body.appendChild(sparkle);

    sparkle.addEventListener('animationend', () => sparkle.remove());
  }

  // Bind both pointer movement and touch dragging
  window.addEventListener('pointermove', handleSparkleMove);
  window.addEventListener('touchmove', handleSparkleMove, { passive: true });
});